export const knownSettings = {
  selectedSummaryItems: "SystemsSummarySelectedSummaryItems"
};
